import React from 'react'

export const LoginPage = React.lazy(() => import('./login'))
export const SettingPage = React.lazy(() => import('./setting'))
export const ResetPasswordPage = React.lazy(() => import('./reset-password'))
export const ForgotPasswordPage = React.lazy(() => import('./forgot-password'))
export const ConfirmOTPPage = React.lazy(() => import('./confirm-otp'))
